import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* SPA is mounted at /reports/ by FastAPI; matching the Vite `base` config. */}
    <BrowserRouter basename="/reports">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
